import { FC, Fragment, useEffect, useRef } from 'react';
import useScript from 'react-script-hook';
import { executeIovationScript } from './executeIovationScript';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        fp_bbout_element_id: string;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        io_bbout_element_id: string;
    }
}

window.fp_bbout_element_id = 'fpBlackBox';
window.io_bbout_element_id = 'ioBlackBox';

interface GreenSkyIovationProps {
    onFingerprintCapture?: (fingerprint: string) => void;
}

export const GreenSkyIovation: FC<GreenSkyIovationProps> = ({ onFingerprintCapture }) => {
    const fpBlackBoxRef = useRef<HTMLInputElement>(null);
    const ioBlackBoxRef = useRef<HTMLInputElement>(null);

    useScript({
        src: 'https://mpsnare.iesnare.com/snare.js',
        checkForExisting: true,
    });

    useEffect(() => {
        executeIovationScript();
    }, []);

    useEffect(() => {
        // Check if fingerprint values are populated and notify parent
        const checkFingerprint = () => {
            const fpBlackBox = fpBlackBoxRef.current?.value ?? '';
            const ioBlackBox = ioBlackBoxRef.current?.value ?? '';

            if (fpBlackBox || ioBlackBox) {
                const fingerprint = `${fpBlackBox};${ioBlackBox}`;
                onFingerprintCapture?.(fingerprint);
            }
        };

        // Check periodically for fingerprint to be populated
        const interval = setInterval(checkFingerprint, 1000);

        // Also check after a delay to give iovation time to populate
        const timeout = setTimeout(checkFingerprint, 3000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [onFingerprintCapture]);

    return (
        <Fragment>
            <input type="hidden" name="fpBlackBox" id="fpBlackBox" ref={fpBlackBoxRef} />
            <input type="hidden" name="ioBlackBox" id="ioBlackBox" ref={ioBlackBoxRef} />
        </Fragment>
    );
};
